import { render, staticRenderFns } from "./UpdateBasicConfig.vue?vue&type=template&id=a76a71ee&"
import script from "./UpdateBasicConfig.vue?vue&type=script&lang=js&"
export * from "./UpdateBasicConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateBasicConfig.vue"
export default component.exports